import ConfirmNewEmail from 'components/Hocs/ColumnsContent';
import RightSidebarFromAuthUser from 'components/UserAccount/RightSidebarFromAuthUser';

import MyPage from './MyPage';

export default ConfirmNewEmail(MyPage, RightSidebarFromAuthUser);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyPage/index.js